export default __webpack_public_path__ + "static/media/howitworksbg.0ff673d0.png";